<template>
  <fb-form-properties-manager id="eoc-vitals-v1-properties-3rvz6z" :fields="fields" :formId="formId" />
</template>

<script>
export default {
  name: "EocVitalsV1Properties",
  props: ["formId"],
  data() {
    return {
      fields: [
        {
          type: "textInput",
          properties: {
            label: "Label"
          },
          property: "label"
        },
        {
          type: "textInput",
          properties: {
            label: "Description"
          },
          property: "description"
        }
      ]
    };
  }
};
</script>

<style></style>
